import { ProjectActions } from '@octopus-do/octopus-project-core'

import { initialLineItem } from './initialLineItem'

export const InitEstimatesAction =
  ProjectActions.estimates.addLineItem(initialLineItem)
